import * as React from "react";
import bodiZahiral from "../../assets/bodi_zahiral.png";

const headingStyle = { fontFamily: '"Sustainability", sans-serif' };
const bodyStyle = { fontFamily: "Sustainability, sans-serif" };

function AboutUs() {
  return (
    <section className="w-full bg-[#fff] mt-14 md:mt-20 pb-16 md:pb-24">
      <div className="max-w-[1400px] min-[1920px]:max-w-[1880px] mx-auto px-4 md:px-8">
        <div className="grid grid-cols-1 md:grid-cols-2 mt-6 md:mt-10 lg:mt-14 gap-y-8 md:gap-y-12">
          <div className="bg-[#fff] px-4 md:px-10 py-8 md:py-14 lg:py-16 flex items-center">
            <div className="max-w-[850px] mx-auto">
              <h2 className="text-[22px] sm:text-[26px] md:text-[32px] lg:text-[42px] text-[#1f1a16] mb-6 md:mb-8 text-center md:text-left leading-tight" style={headingStyle}>
                ROOTS AND NEW BEGINNINGS
              </h2>
              <p className="text-[13px] sm:text-[12px] md:text-[13px] lg:text-[14px] min-[1920px]:text-[14px] leading-[1.75] md:leading-[1.85] text-[#5f574c] font-light text-left" style={bodyStyle}>
                We began BODIOS during a time of great change in Mongolia. As a young person of 21, I saw 
                not only a new beginning for myself but also for my community. The shift from a centrally 
                planned to a market economy inspired me to start one of the first private cooperatives in our 
                region—not just to run a business, but to lift herding families and build something meaningful 
                and lasting together.
              </p>
            </div>
          </div>
          <div className="w-full flex justify-center items-center py-4">
            <img
              src="https://cdn.builder.io/api/v1/image/assets/9804d3a088fa478e8672485264720a14/b5dcf6fe1b98f09c8c92efddefd21a3f4b63b89aaf6d85874096b9de34aa9917?apiKey=9804d3a088fa478e8672485264720a14&"
              alt="About Bodios"
              className="w-full max-w-[460px] md:max-w-[500px] aspect-[64/43] object-cover object-top min-[1920px]:w-[910px] min-[1920px]:h-[660px] min-[1920px]:max-w-none min-[1920px]:aspect-auto"
            />
          </div>
          <div className="w-full flex justify-center items-center py-4">
            <img
              src={bodiZahiral}
              alt="People sitting under a tree"
              className="w-full max-w-[460px] md:max-w-[500px] aspect-[64/43] object-cover object-top min-[1920px]:w-[910px] min-[1920px]:h-[660px] min-[1920px]:max-w-none min-[1920px]:aspect-auto"
            />
          </div>

          <div className="bg-[#fff] px-4 md:px-10 py-8 md:py-14 lg:py-16 flex items-center">
            <div className="max-w-[850px] mx-auto">
              <h3 className="text-[22px] sm:text-[26px] md:text-[32px] lg:text-[42px] text-[#1f1a16] mb-6 md:mb-8 text-center md:text-left leading-tight" style={headingStyle}>
                HONORING HERDING TRADITIONS
              </h3>
              <p className="text-[13px] sm:text-[12px] md:text-[13px] lg:text-[14px] min-[1920px]:text-[14px] leading-[1.75] md:leading-[1.85] text-[#5f574c] font-light text-left" style={bodyStyle}>
                BODIOS, named after our family, began in 1991 with the founding of Baylag-Ulzii in 
                Bayankhongor. In this remote province of Mongolia’s Gobi-mountain region, herding is not just 
                a job—it’s a way of life that shapes our identity and values.
                I grew up among herders who raised yaks, goats, and camels in some of Mongolia’s toughest 
                landscapes. I started small—gathering fibres from those closest to us, trusting in the wisdom 
                passed down through generations. Our dream was simple but powerful: to care for our 
                community, give local herders the respect they deserve, and create products that honor the 
                strength and resilience of our people and land. Every piece we make carries a part of our story 
                and our gratitude to those who support us.
                That spirit is still at the heart of BODIOS today. We are deeply rooted in our community, guided 
                by the rhythms of nature, and committed to preserving Mongolia’s traditions. Every partnership 
                we form and every product we create is built on a foundation of respect—for our land, for our 
                people, and for you, our customers, who make this journey possible.
                BODIOS is proudly Mongolian owned, specializing in wool and cashmere clothing made with 
                care and heritage at our heart.
              </p>
            </div>
          </div>

          <div className="bg-[#fff] px-4 md:px-10 py-8 md:py-14 lg:py-16 flex items-center">
            <div className="max-w-[850px] mx-auto">
              <h3 className="text-[22px] sm:text-[26px] md:text-[32px] lg:text-[42px] text-[#1f1a16] mb-6 md:mb-8 text-center md:text-left leading-tight" style={headingStyle}>
                FROM OUR LAND TO YOUR HANDS
              </h3>
              <p className="text-[13px] sm:text-[12px] md:text-[13px] lg:text-[14px] min-[1920px]:text-[14px] leading-[1.75] md:leading-[1.85] text-[#5f574c] font-light text-left" style={bodyStyle}>
                Since 2008, we’ve dedicated ourselves to making high-quality knitted and woven products from 
                yak wool, cashmere, and other natural fibers, honoring the skills of our herding communities 
                and the gifts of our land.
                Over the years, we’ve learned to carefully source and prepare our raw materials, ensuring that 
                every step—from gathering the fibres to crafting the final product—reflects our commitment to 
                quality and respect for tradition.
                "In the early 2000s, my wife and I also worked as tour guides, welcoming guests from near and 
                far. We realized that yak down, like cashmere, could be gently collected before it was lost to the 
                wind. Our goal was to create a sustainable livelihood that would help our herding community 
                preserve their traditions. BODIOS was born from our land, our family, and our shared story." —
                My wife, Munkhtuya, and I welcomed visitors from all over the world, sharing Mongolia’s rich 
                culture and showing them places only locals knew. Our deep connection to the land and our 
                people inspired us to share Mongolia in a new way—through beautifully made natural fibre 
                products. This vision became the heart of the BODIOS brand.
                Today, more than 30 percent of BODIOS products travel from Mongolia to homes across 
                Europe, North America, and Asia. Our customers know us for warmth—both in our natural, 
                environmentally responsible products and in the care, we put into every step. We’re deeply 
                proud of our commitment to quality, sustainability, and the true craftsmanship that honors our 
                heritage and your trust.
              </p>
            </div>
          </div>

          <div className="w-full flex justify-center items-center py-4">
            <img
              src="https://cdn.builder.io/api/v1/image/assets/9804d3a088fa478e8672485264720a14/298048f44cb87f8a912c8acdf1919739c268f331054c18a3a9d5fa2ee36ac044?apiKey=9804d3a088fa478e8672485264720a14&"
              alt="Brown sheep portrait"
              className="w-full max-w-[460px] md:max-w-[500px] aspect-[64/43] object-cover min-[1920px]:w-[910px] min-[1920px]:h-[660px] min-[1920px]:max-w-none min-[1920px]:aspect-auto"
            />
          </div>

        </div>
      </div>
    </section>
  );
}

export default AboutUs;